import script from "./NotSubmitted.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotSubmitted.vue?vue&type=script&setup=true&lang=ts"

import "./NotSubmitted.vue?vue&type=style&index=0&id=3e7a377b&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e7a377b"]])

export default __exports__